var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccoutSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C13.5313 11 15.5833 8.94795 15.5833 6.41665C15.5833 3.88534 13.5313 1.83331 11 1.83331C8.46868 1.83331 6.41666 3.88534 6.41666 6.41665C6.41666 8.94795 8.46868 11 11 11Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12582 20.1667C3.12582 16.6192 6.65499 13.75 11 13.75C11.88 13.75 12.7325 13.8692 13.53 14.0892",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6354 14.8274V17.2516C13.6354 18.1423 13.6354 18.1423 14.4757 18.7095L16.7864 20.0456C17.1352 20.2472 17.7024 20.2472 18.0469 20.0456L20.3576 18.7095C21.1979 18.1423 21.1979 18.1423 21.1979 17.2559V14.8274C21.1979 13.941 21.1979 13.941 20.3576 13.3738L18.0469 12.0377C17.7024 11.8361 17.1352 11.8361 16.7864 12.0377L14.4757 13.3738C13.6354 13.941 13.6354 13.941 13.6354 14.8274Z",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 17.3021C18.1128 17.3021 18.6771 16.7378 18.6771 16.0417C18.6771 15.3456 18.1128 14.7812 17.4167 14.7812C16.7206 14.7812 16.1562 15.3456 16.1562 16.0417C16.1562 16.7378 16.7206 17.3021 17.4167 17.3021Z",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccoutSettings);
export default __webpack_public_path__ + "static/media/AccoutSettings.35ab20a5ed19bda627bea656e91399db.svg";
export { ForwardRef as ReactComponent };